import translateMixin from "@/components/mixins/translateMixin";

function getFlairFeaturesTextCupSize(value) {
    return value.from + ' - ' + value.to + ' ' + _.get(this, 'translate.user_features.cup', '');
}

function getFlairFeaturesTextSlider(name, value) {
    if (!value.length || value.length < 2) {
        return '';
    }
    let text = value[0] + ' - ' + value[1];

    if (name === 'age') {
        text += ' ' + _.get(this, 'translate.user_features.years_old');
    } else if (name === 'height') {
        text += 'cm';
    } else if (name === 'weight') {
        text += 'kg';
    }

    return text;
}

function getFlairFeaturesTextList(name, value) {
    value = this.translateFeature(value, name)
    switch (name) {
        case 'nationality' :
            return _.get(this, 'translate.user_features.nationality', '') + ': ' + value;
        case 'hair_color' :
            return value + ' ' + _.get(this, 'translate.user_features.hair', '');
        case 'eye_color' :
            return value + ' ' + _.get(this, 'translate.user_features.eyes', '');
        case 'breast_size' :
        case 'breast_type' :
            return value + ' ' + _.get(this, 'translate.user_features.breasts', '');
        case 'pubic_hair' :
            return value + ' ' + _.get(this, 'translate.user_features.pubic_hair', '');
        default :
            return value;
    }
}

function getFlairFeaturesTextMobile(features) {
    const result = [];

    if (_.has(features, 'cup_size.from', false)) {
        result.push(this.getFlairFeaturesTextCupSize(features.cup_size));
    }

    if (Object.keys(_.get(features, 'sliders', {})).length) {
        _.each(_.keys(features.sliders), key => {
            result.push(this.getFlairFeaturesTextSlider(key, features.sliders[key]));
        });
    }

    if (Object.keys(_.get(features, 'lists', {})).length) {
        _.each(_.keys(features.lists), key => {
            _.each(features.lists[key], value => {
                result.push(this.getFlairFeaturesTextList(key, value));
            });
        });
    }

    return result.join(', ');
}

function removeFeaturesFlairSlider(features, sliderName) {
    if (Object.keys(features.sliders).length > 1) {
        delete features.sliders[sliderName];
    } else {
        delete features.sliders;
    }
    return features;
}

function removeFeaturesFlairList(features, listName, value) {
    _.remove(features.lists[listName], val => _.isEqual(val, value));
    return features;
}

const data = () => ({
    store: $store,
});

export default {
    data,
    computed: {
        ...mapState(['translate']),
    },
    mixins: [translateMixin],
    methods: {
        getFlairFeaturesTextCupSize,
        getFlairFeaturesTextSlider,
        getFlairFeaturesTextList,
        removeFeaturesFlairSlider,
        removeFeaturesFlairList,
        getFlairFeaturesTextMobile,
    },
}
